export enum Dicionario {
    CONTA_DE_USUARIO = 3,
    BIOMETRIA = 4,
    TELEFONE = 5,
    ANIMAL = 6,
    TAG = 7,
    FUNCIONARIO = 8,
    VISITANTE = 9,
    EMPRESA = 10,
    GRUPO_BLOQUEIO = 11,
    GRUPO_LIBERACAO = 12,
    // CARTOES = 13,
    RELATORIO_DE_ACESSO = 14,
    RELATORIO_CADASTRAL = 15,
    RELATORIO_ESTATISTICA = 16,
    //RELATORIO_CARTAO = 17,
    HORARIO = 19,
    LOCAL_DE_ACESSOS = 20,
    GRUPOS_PERMISSOES = 22,
    GRUPO = 24,
    DICIONARIO = 25,
    AUTORIZACAO_DE_ACESSO = 26,
    BLOQUEIO_DA_PESSOA = 27,
    MOTIVO = 28,
    SETOR = 31,
    PERFIL_DE_ACESSO = 32,
    VINCULO = 33,
    AUDITORIA = 34,
    MORADOR = 35,
    ALUNO = 36,
    VEICULO = 37,
    //TABELA_EXCEL = 38,
    CONFIGURACAO_SISTEMA = 39,
    CONSULTA_BANCO_DADOS = 40,
    ALTERAR_TIPO_USUARIO = 42,
    RELATORIO_BANCO_DE_DADOS = 46,
    //RELATORIO_VAGAS_OCUPADAS = 47,
    LOCAL_EVENTO = 48,
    EVENTO = 49,
    BLOQUEIO_LOCAL = 50,
    USUARIO_EVENTO = 51,
    BUSCA_RAPIDA = 53,
    IMPORTACAO_FUNCIONARIO = 54,
    CONVIDADO = 55,

    OBJETO = 65,
    PODERES = 66,
    COR = 67,
    DIA_SEMANA = 68,
    DISPOSITIVO = 69,
    HISTORICO = 70,
    HORARIO_ITENS = 71,
    OPERADORA = 73,
    TIPO_TELEFONE = 74,
    UPLOAD = 75,
    COMANDO = 76,
    SECAO = 83,
    LISTA = 84,
    ETIQUETA = 85,
    COMENTARIO = 86,
    ATIVIDADE = 87,
    OCORRENCIA = 88,
    ASSUNTO_OCORRENCIA = 89,
    EVENTO_NOME = 90,
    SERVICO = 91,
    FORNECEDOR = 92,
    CLIENTE = 93,
    PLANO = 94,
    FATURA = 95,
    TIPO_COMANDO = 96,
    REFEITORIO = 97,
    DOCUMENTO = 98,
    TIPO_SERVICO = 99,
    CHAT = 100,
    AVISO = 101,
    PRODUTO = 102,
    ESTOQUE = 103,
    RELATORIO_ESTOQUE = 104,
    ESTOQUE_AVANCADOS = 105,
}